import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';
import { api } from './lib/api.js';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App api={api} />
  </StrictMode>,
);
